// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sc-2";
export var chatLink = "_sc-0";
export var chatText = "_sc-1";